import React from 'react'
import CarouselCustomNavigation from '../Carousel/carousel'
import ComplexNavbar from '../navbar/Navbar'
import Category from '../ProductContent/CategoryFilter'
import Arrival from '../ProductContent/Arrival'
import ProductSuggestion from '../ProductContent/ProductSugestion'
import Footer from '../Footer/footer'

export default function Product() {
  return (
    <div>
        <ComplexNavbar/>
<CarouselCustomNavigation/>
<div className="bg-white py-6 sm:py-8 lg:py-12">
  <div className="mx-auto max-w-screen-2xl px-4 md:px-8">
    <div className="rounded-lg bg-gray-100 px-4 py-6 md:py-8 lg:py-12">
      <p className="mb-2 text-center font-semibold text-green-500 md:mb-3 lg:text-lg">
    Product
      </p>
      <h2 className="mb-4 text-center text-2xl font-bold text-gray-800 md:mb-6 lg:text-3xl">
      Ghazni Cooking Oil
    <h2 style={{border:"1px solid green",width:""}} ></h2>
      </h2>
     
    </div>
  </div>
</div>

<Category/>
<Arrival/>
<br />
<br />
<br />
<br />

<br /><br />
<Footer/>

    </div>
  )
}
